
let _ = require('../_.js');
let $ = jQuery;

// Code related to tracking which users are logged in or are otherwise participating in auction activities.
// The following data is sent as it is updated as key value pairs to topic 'browser':

// auction_id: The id of the currently browsed auction if any
// url:  The id of the currently browsed url
// os: One of these: 'Mac OS' 'iPhone' 'iPad' 'Windows' 'Android-Phone' 'Android-Tablet' 'Linux' 'Unknown'
// is_mobile: true/false if mobile viewport sized
// resolution: screen resolution width in the browser
// idle: if idle for more than 60 seconds, this returns the current secondsidle time of the browser, otherwise returns false.

// There may be more data returned in the future.  The transmitting function and the backend receiving function is written
// in a generic way to record any key/value pair we wish to track per client.

_.ac_activity_init = async function () {

    let is_poised_viewport = false;  // The mouse is hovering over the bidding area
    let is_poised_modal = false;     // A bidding confirmation window is open

    // Send initial analytics data, and queue up listeners for when the data
    // needs to be re-sent or the data has been updated
    let _lets_go = async function () {
        // Initial checkin
        _refresh_data();

        // Update when session changes
        _.AuctionUI_Session.session_updated_handler(_refresh_data);

        // Update on browser resize events
        _.on_ui_resize(_refresh_data)

        // Refresh when we are asked to
        _.on_websocket_receive(function (topic, data) {
            if (topic == "env_update") {
                data_sent = {};
                _refresh_data();
            }
        });

        // Refresh when we lose our ws connection
        _.on_websocket_disconnected(function () {
            data_sent = {};
            _refresh_data();
        });
    }

    // This collects the data to send.  We send all of it to the browser_send_websocket_update()
    // function every time.
    // Some of the callbacks require this function to be synchronous, but that is simply a security / state integrity check.  Since
    // this function doesn't affect anything else in the program state it is ok if this is asynchronous.  So we are using a synchronous
    // function to define and execute an asynchronous function that will deliver this update.
    let _refresh_data = function () {
        _.decorated(_, "_refresh_data", _.debounce(250, async function () {

            let registrant = await _.AuctionUI_Session.get_registrant();
            let current_round = await _.AuctionUI.get_current_round();

            // Only a logged-in bidder's details are shown to the clerk (bidder list: idle, lag, device,
            // poised). An anonymous viewer is only counted, so it sends where it is and nothing else.
            _.websocket_report_latency = !!registrant;

            // Who the bidder is comes from the signed token (registrant_auth, wp_lib/session.js), never from env
            let data_to_send = {
                auction_id: _.AuctionUI.auction_id() ? _.AuctionUI.auction_id() : null,
                url: document.location.pathname,
            };

            if (!registrant) {
                browser_send_websocket_update(data_to_send);
                return;
            }

            data_to_send.os = _.getOS();
            data_to_send.is_mobile = _.isMobileDevice();
            data_to_send.resolution = window.innerWidth;
            data_to_send.is_poised = (is_poised_viewport || is_poised_modal) && current_round ? current_round.id : false;

            // Only transmit when idle starts, how many seconds it has been since idle state started.  It will be up to the
            // websocket server to track when that time is based on the offset of seconds idle and when it received the 
            // message.  We don't need to continuously transmit updates on how many seconds the browser has been idle for.
            let idle_message = is_idle ? (Math.floor(((new Date()) - idleStarted) / 1000) + 60) : false;
            if (!data_sent.idle || data_sent.idle === false && idle_message !== false || data_sent.idle !== false && idle_message === false) {
                data_to_send.idle = idle_message;
            }

            browser_send_websocket_update(data_to_send);
        }));
    }

    // This function determines what we have not yet sent to the current websocket session,
    // and sends it.
    let data_sent = {}
    let browser_send_websocket_update = function (data) {
        let data_to_transmit = {};
        let should_transmit_data = false;

        for (let i in data) {
            if (data.hasOwnProperty(i)) {
                if (typeof (data_sent[i]) == "undefined" || data_sent[i] !== data[i]) {
                    data_to_transmit[i] = data[i];
                    data_sent[i] = data[i];
                    should_transmit_data = true;
                }
            }
        }

        if (should_transmit_data) {
            // console.log("Transmitting env data", data_to_transmit);
            _.websocket_send("env", data_to_transmit);
        }
    }


    // An implementation of a simple timer which transmits that
    // idle state has started if the browser hasn't done anything for 60 seconds.
    // Once the browser does something idle state will be abandoned.  
    // If we assume that as soon as any 
    let idleTimer = null;
    let idleTimeout = 60 * 1000; // 60 seconds
    let idleStarted = new Date();
    let is_idle = false;

    function startIdleTimer() {
        // Clear the existing timer
        if (idleTimer) clearTimeout(idleTimer);

        // Set a new timer
        idleTimer = setTimeout(function () {
            is_idle = true;
            idleStarted = new Date();
            _refresh_data();
        }, idleTimeout);
    }

    function resetIdleTimer() {
        if (is_idle) {
            is_idle = false;
            _refresh_data();
        }
        startIdleTimer();
    }

    // List of common events that are clear signs of user activity
    $.each(['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'], function (i, eventName) {
        $(window).on(eventName, resetIdleTimer);
    });

    // Track the is_poised_viewport state - if the user is hovering over ac-component-bid they are considered poised.
    _.on_ui_update_once(".ac-component-bid", function () {
        $(this).mouseenter(function () {
            if ((window.innerWidth || document.documentElement.clientWidth) >= 700) {
                is_poised_viewport = true;
                _refresh_data();
            }
        }).mouseleave(function () {
            if ((window.innerWidth || document.documentElement.clientWidth) >= 700) {
                is_poised_viewport = false;
                _refresh_data();
            }
        });
    });

    // Track poised via modal windows - confirm bid modals open count as poised
    _.set_poised_modal = function (state) {
        is_poised_modal = state;
        _refresh_data();
    }

    // Track poised on mobile - just have to be able to see the bid button
    let _was_mobile_poised = false;
    let _mobile_scroll_poised_check = function () {
        if ((window.innerWidth || document.documentElement.clientWidth) < 750) {
            function _isElementInViewport(el) {
                try {
                    var rect = el.getBoundingClientRect();
                    return (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
                } catch (e) {
                    return false;
                }
            }
            if (
                _isElementInViewport($(".ac-btn-quickbid:visible")[0])
            ) {
                if (!is_poised_viewport) {
                    is_poised_viewport = true;
                    _was_mobile_poised = true;
                    _refresh_data();
                }
            } else {
                if (is_poised_viewport) {
                    is_poised_viewport = false;
                    _was_mobile_poised = false;
                    _refresh_data();
                }
            }
        } else {
            if (_was_mobile_poised) {
                is_poised_viewport = false;
                _was_mobile_poised = false;
                _refresh_data();
            }
        }
    }

    $(window).scroll(_mobile_scroll_poised_check);
    _mobile_scroll_poised_check();

    setInterval(function () {
        if (is_poised_modal && !$(".lp-modal").is(":visible")) {
            is_poised_modal = false;
            _refresh_data();
        }
    }, 1000);

    // Start the idle timer when the script loads
    startIdleTimer();

    // THATS IT!  This starts it.
    if (!_.isCrawler()) {
        _lets_go();
    }
}